/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_No_ParentInputs */

const en_prop_no_parent = /** @type {(inputs: Prop_No_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No parent`)
};

const de_prop_no_parent = /** @type {(inputs: Prop_No_ParentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

/**
* | output |
* | --- |
* | "No parent" |
*
* @param {Prop_No_ParentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_no_parent = /** @type {((inputs?: Prop_No_ParentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_No_ParentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_no_parent(inputs)
	return en_prop_no_parent(inputs)
});